module.exports = __webpack_public_path__ + "media/images/banner-efdfd1f1400d2ad4d0337d093d97804c.png";